import React, { Component } from "react";
import PropTypes from "prop-types";
import { LaneShape, rangeLabelsMap } from "../../utils";
import RightDrawer from "../RightDrawer";
import ChangeLaneStatus from "./ChangeLaneStatus";
import ChangeLaneAssigment from "./ChangeLaneAssigment";

class LaneDrawer extends Component {
  constructor(props) {
    super(props);
    this.handleGetDrawerVisible = this.handleGetDrawerVisible.bind(this);
    this.handleChangeLaneStatus = this.handleChangeLaneStatus.bind(this);
    this.handleBackToQueue = this.handleBackToQueue.bind(this);
    this.handleClearToCheckout = this.handleClearToCheckout.bind(this);
  }

  handleGetDrawerVisible() {
    return !!this.props.editLane;
  }

  handleChangeLaneStatus(newStatus) {
    const { onChangeLane, editLane } = this.props;
    onChangeLane(editLane.location, editLane.range, editLane.laneNumber, {
      status: newStatus,
    });
  }

  handleBackToQueue() {
    const { onBackToQueue, editLane } = this.props;
    onBackToQueue(editLane.location, editLane.range, editLane.laneNumber);
  }

  handleClearToCheckout() {
    const { onChangeLane, editLane } = this.props;
    onChangeLane(editLane.location, editLane.range, editLane.laneNumber, {
      assignment: null,
      status: "open",
    });
  }

  render() {
    const { onCompleteEditLane, editLane } = this.props;
    const rangeLabel =
      editLane && editLane.range
        ? rangeLabelsMap[editLane.range] || editLane.range
        : "";
    return (
      <RightDrawer
        className="lane-drawer"
        onToggleDrawer={onCompleteEditLane}
        onCloseDrawer={onCompleteEditLane}
        getDrawerVisible={this.handleGetDrawerVisible}
        title={
          editLane &&
          `${rangeLabel.toUpperCase()} - LANE #${
            editLane.laneNumber
          } - ${editLane.lane.status.replace("-", " ").toUpperCase()}`
        }
      >
        <div className="md-grid">
          <div className="md-cell md-cell--12">
            {editLane &&
              (editLane.lane.status.toLowerCase() !== "in-use" ? (
                <ChangeLaneStatus
                  onLaneStatusChange={this.handleChangeLaneStatus}
                  status={editLane.lane.status}
                />
              ) : (
                <ChangeLaneAssigment
                  assignment={editLane.lane.assignment}
                  onBackToQueue={this.handleBackToQueue}
                  onClearToCheckout={this.handleClearToCheckout}
                />
              ))}
          </div>
        </div>
      </RightDrawer>
    );
  }
}

LaneDrawer.propTypes = {
  editLane: LaneShape,
  onChangeLane: PropTypes.func.isRequired,
  onBackToQueue: PropTypes.func.isRequired,
  onCompleteEditLane: PropTypes.func.isRequired,
};

LaneDrawer.defaultProps = {
  editLane: null,
};

export default LaneDrawer;



// WEBPACK FOOTER //
// ./src/staff/components/LaneDrawer/LaneDrawer.jsx